"use strict";

var _inherits = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");
var _createSuper = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");
var _classCallCheck = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UTF_32LE = exports.UTF_32BE = exports.UTF_16LE = exports.UTF_16BE = void 0;
var match_1 = __importDefault(require("../match"));
var UTF_16BE = /*#__PURE__*/function () {
  function UTF_16BE() {
    _classCallCheck(this, UTF_16BE);
  }
  _createClass(UTF_16BE, [{
    key: "name",
    value: function name() {
      return 'UTF-16BE';
    }
  }, {
    key: "match",
    value: function match(det) {
      var input = det.rawInput;
      if (input.length >= 2 && (input[0] & 0xff) == 0xfe && (input[1] & 0xff) == 0xff) {
        return (0, match_1.default)(det, this, 100);
      }
      return null;
    }
  }]);
  return UTF_16BE;
}();
exports.UTF_16BE = UTF_16BE;
var UTF_16LE = /*#__PURE__*/function () {
  function UTF_16LE() {
    _classCallCheck(this, UTF_16LE);
  }
  _createClass(UTF_16LE, [{
    key: "name",
    value: function name() {
      return 'UTF-16LE';
    }
  }, {
    key: "match",
    value: function match(det) {
      var input = det.rawInput;
      if (input.length >= 2 && (input[0] & 0xff) == 0xff && (input[1] & 0xff) == 0xfe) {
        if (input.length >= 4 && input[2] == 0x00 && input[3] == 0x00) {
          return null;
        }
        return (0, match_1.default)(det, this, 100);
      }
      return null;
    }
  }]);
  return UTF_16LE;
}();
exports.UTF_16LE = UTF_16LE;
var UTF_32 = /*#__PURE__*/function () {
  function UTF_32() {
    _classCallCheck(this, UTF_32);
  }
  _createClass(UTF_32, [{
    key: "name",
    value: function name() {
      return 'UTF-32';
    }
  }, {
    key: "getChar",
    value: function getChar(_input, _index) {
      return -1;
    }
  }, {
    key: "match",
    value: function match(det) {
      var numValid = 0,
        numInvalid = 0,
        hasBOM = false,
        confidence = 0;
      var limit = det.rawLen / 4 * 4;
      var input = det.rawInput;
      if (limit == 0) {
        return null;
      }
      if (this.getChar(input, 0) == 0x0000feff) {
        hasBOM = true;
      }
      for (var i = 0; i < limit; i += 4) {
        var ch = this.getChar(input, i);
        if (ch < 0 || ch >= 0x10ffff || ch >= 0xd800 && ch <= 0xdfff) {
          numInvalid += 1;
        } else {
          numValid += 1;
        }
      }
      if (hasBOM && numInvalid == 0) {
        confidence = 100;
      } else if (hasBOM && numValid > numInvalid * 10) {
        confidence = 80;
      } else if (numValid > 3 && numInvalid == 0) {
        confidence = 100;
      } else if (numValid > 0 && numInvalid == 0) {
        confidence = 80;
      } else if (numValid > numInvalid * 10) {
        confidence = 25;
      }
      return confidence == 0 ? null : (0, match_1.default)(det, this, confidence);
    }
  }]);
  return UTF_32;
}();
var UTF_32BE = /*#__PURE__*/function (_UTF_) {
  _inherits(UTF_32BE, _UTF_);
  var _super = _createSuper(UTF_32BE);
  function UTF_32BE() {
    _classCallCheck(this, UTF_32BE);
    return _super.apply(this, arguments);
  }
  _createClass(UTF_32BE, [{
    key: "name",
    value: function name() {
      return 'UTF-32BE';
    }
  }, {
    key: "getChar",
    value: function getChar(input, index) {
      return (input[index + 0] & 0xff) << 24 | (input[index + 1] & 0xff) << 16 | (input[index + 2] & 0xff) << 8 | input[index + 3] & 0xff;
    }
  }]);
  return UTF_32BE;
}(UTF_32);
exports.UTF_32BE = UTF_32BE;
var UTF_32LE = /*#__PURE__*/function (_UTF_2) {
  _inherits(UTF_32LE, _UTF_2);
  var _super2 = _createSuper(UTF_32LE);
  function UTF_32LE() {
    _classCallCheck(this, UTF_32LE);
    return _super2.apply(this, arguments);
  }
  _createClass(UTF_32LE, [{
    key: "name",
    value: function name() {
      return 'UTF-32LE';
    }
  }, {
    key: "getChar",
    value: function getChar(input, index) {
      return (input[index + 3] & 0xff) << 24 | (input[index + 2] & 0xff) << 16 | (input[index + 1] & 0xff) << 8 | input[index + 0] & 0xff;
    }
  }]);
  return UTF_32LE;
}(UTF_32);
exports.UTF_32LE = UTF_32LE;